import { render, staticRenderFns } from "./ContactsEditModal.vue?vue&type=template&id=0ed792f2&scoped=true"
import script from "./ContactsEditModal.vue?vue&type=script&lang=js"
export * from "./ContactsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed792f2",
  null
  
)

export default component.exports